import { lazy, Suspense } from "react";
import { Loading } from "../sharedComponents";
import Refunds from "../pages/Payments/Refunds";

// Lazy loading ile sayfa import'ları
const AddBranchPage = lazy(() =>
  import("../pages/AddBranchPage/AddBranchPage")
);
const AdminStatisticPage = lazy(() =>
  import("../pages/AdminStaticticPage/AdminStatisticPage")
);
const AnnouncementPage = lazy(() =>
  import("../pages/Announcement/AnnouncementPage")
);
const StudentsForAdmin = lazy(() => import("../pages/StudentsForAdmin/Students"));
const Settings = lazy(() => import("../pages/Settings/Settings"));

const BranchDashboard = lazy(() => import("../pages/Branch/BranchDashboard"));
const CategoryPage = lazy(() => import("../pages/Categories/CategoryPage"));
const CevrimiciDetay = lazy(() =>
  import("../pages/CevrimciDetay/CevrimiciDetay")
);
const ActiveCourseDashboard = lazy(() =>
  import("../pages/Course/ActiveCourseDashboard")
);
const CourseDetailPage = lazy(() => import("../pages/Course/CourseDetailPage"));
const CourseUpdatePage = lazy(() => import("../pages/Course/CourseUpdatePage"));
const CreateOnlineCoursePage = lazy(() =>
  import("../pages/Course/CreateOnlineCoursePage")
);
const StudentCourseDashboard = lazy(() =>
  import("../pages/Course/StudentCourseDashboard")
);
const TeacherCoursePage = lazy(() =>
  import("../pages/Course/TeacherCoursePage")
);
const Dashboard = lazy(() => import("../pages/Dashboard/Dashboard"));
const LiveControl = lazy(() => import("../pages/LiveControl/LiveControl"));
const Applications = lazy(() => import("../pages/Applications/Applications"));
const EditBranchPage = lazy(() =>
  import("../pages/EditBranchPage/EditBranchPage")
);
const PaymentControl = lazy(() => import("../pages/Odeme/PaymentControl"));
const OgrenciDevamsızlıkPage = lazy(() =>
  import("../pages/OgrenciDevamsızlıkPage/OgrenciDevamsızlıkPage")
);
const OgrencilerimPage = lazy(() =>
  import("../pages/Ogrencilerim/OgrencilerimPage")
);
const ProfilePage = lazy(() => import("../pages/Profile/ProfilePage"));
const RemoveAbsences = lazy(() =>
  import("../pages/RemoveAbsences/RemoveAbsences")
);
const SmsPage = lazy(() => import("../pages/SmsPage/SmsPage"));
const StudentDasboard = lazy(() => import("../pages/Student/StudentDasboard"));
const StudentMessagePage = lazy(() =>
  import("../pages/Student/StudentMessagePage/StudentMessagePage")
);
const UpdateStudentPage = lazy(() =>
  import("../pages/Student/UpdateStudentPage")
);
const Payments = lazy(() => import("../pages/Payments/Payments"));
const StudentForTeacher = lazy(() =>
  import("../pages/StudentForTeacher/StudentForTeacher")
);
const StudentOnlineMeeting = lazy(() =>
  import("../pages/StudentOnlineMeeting/StudentOnlineMeeting")
);
const Tallys = lazy(() => import("../pages/Tally/Tallys"));
const AddTeacherPage = lazy(() => import("../pages/Teacher/AddTeacherPage"));
const EditTeacherPage = lazy(() => import("../pages/Teacher/EditTeacherPage"));
const TeacherDashboard = lazy(() =>
  import("../pages/Teacher/TeacherDashboard")
);
const TeacherMessagePage = lazy(() =>
  import("../pages/Teacher/TeacherMessagePage")
);
const TeacherExamPage = lazy(() =>
  import("../pages/TeacherExam/TeacherExamPage")
);
const TeacherOnlineMeetingPage = lazy(() =>
  import("../pages/TeacherOnlineMeeting/TeacherOnlineMeetingPage")
);
const TeacherOnlineMeetingWorksPage = lazy(() =>
  import("../pages/TeacherOnlineMeeting/TeacherOnlineMeetingWorksPage")
);
const DietitianAppointmentPage = lazy(() =>
  import("../pages/Dietitian/DietitianAppointmentPage")
);
const DietitianRegistrationPage = lazy(() =>
  import("../pages/Dietitian/DietitianRegistrationPage")
);
const DietitianResponsibleAppointments = lazy(() =>
  import("../pages/Dietitian/DietitianResponsibleAppointments")
);
const MyApplications = lazy(() => import("../pages/Dietitian/MyApplications"));
const DietitianOnlineMeetingPage = lazy(() =>
  import("../pages/Dietitian/DietitianOnlineMeetingPage")
);
const DietitianManagementDashboard = lazy(() =>
  import("../pages/Dietitian/DietitianManagement/DietitianDashboard")
);
const AddDietitianPage = lazy(() =>
  import("../pages/Dietitian/DietitianManagement/AddDietitianPage")
);
const DieticianDetails = lazy(() =>
  import("../pages/Dietitian/DieticianDetails")
);
const DieticianEducationDetails = lazy(() =>
  import("../pages/Dietitian/DieticianEducationDetails")
);
const EditDietitianPage = lazy(() =>
  import("../pages/Dietitian/DietitianManagement/EditDietitianPage")
);
const GenelBilgiler = lazy(()=>import("../pages/GenelBilgiler/GenelBilgiler"));

export const roles = [
  "Süper Admin",
  "Admin",
  "Öğretmen",
  "Öğrenci",
  "Diyetisyen",
];

export const privateRoutes = [
  {
    path: "/canli-egitim-kontrol",
    component: (
      <Suspense fallback={<Loading />}>
        <LiveControl />
      </Suspense>
    ),
    roles: ["Süper Admin", "Admin", "Öğretmen", "Öğrenci", "Diyetisyen"],
  },
  {
    path: "/basvurular",
    component: (
      <Suspense fallback={<Loading />}>
        <Applications />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
  {
    path: "/geriodemeler",
    component: (
      <Suspense fallback={<Loading />}>
        <Refunds />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
  {
    path: "/",
    component: (
      <Suspense fallback={<Loading />}>
        <Dashboard />
      </Suspense>
    ),
    roles: [...roles],
  },
  {
    path: "/egitmen",
    component: (
      <Suspense fallback={<Loading />}>
        <TeacherDashboard />
      </Suspense>
    ),
    roles: ["Admin", "Süper Admin"],
  },
  {
    path: "/egitmen/ekle",
    component: (
      <Suspense fallback={<Loading />}>
        <AddTeacherPage />
      </Suspense>
    ),
    roles: ["Admin", "Süper Admin"],
  },
  {
    path: "/egitmen/duzenle/:id",
    component: (
      <Suspense fallback={<Loading />}>
        <EditTeacherPage />
      </Suspense>
    ),
    role: ["Admin", "SüperAdmin"],
  },
  {
    path: "/ogrenciler", 
    component: (
      <Suspense fallback={<Loading />}>
        <StudentsForAdmin /> 
      </Suspense>
    ),
    roles: ["Admin", "Süper Admin"],
  },
   {
    path: "/ayarlar", 
    component: (
      <Suspense fallback={<Loading />}>
        <Settings /> 
      </Suspense>
    ),
    roles: ["Admin", "Süper Admin"],
  },
  {
    path: "/branslar",
    component: (
      <Suspense fallback={<Loading />}>
        <BranchDashboard />
      </Suspense>
    ),
    roles: ["Admin", "Süper Admin"],
  },
  {
    path: "/brans/ekle",
    component: (
      <Suspense fallback={<Loading />}>
        <AddBranchPage />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
  {
    path: "/brans/duzenle/:id",
    component: (
      <Suspense fallback={<Loading />}>
        <EditBranchPage />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
  {
    path: "/kullanıcılar",
    component: (
      <Suspense fallback={<Loading />}>
        <StudentDasboard />
      </Suspense>
    ),
    roles: ["Admin", "Süper Admin"],
  },
  {
    path: "/kategori",
    component: (
      <Suspense fallback={<Loading />}>
        <CategoryPage />
      </Suspense>
    ),
    roles: ["Admin", "Süper Admin"],
  },
  {
    path: "/ogrenci/duzenle/:id",
    component: (
      <Suspense fallback={<Loading />}>
        <UpdateStudentPage />
      </Suspense>
    ),
    roles: ["Admin", "Süper Admin"],
  },
  {
    path: "/cevrimici",
    component: (
      <Suspense fallback={<Loading />}>
        <ActiveCourseDashboard />
      </Suspense>
    ),
    roles: ["Admin", "Süper Admin", "Öğrenci"],
  },
  {
    path: "/kurs/:id",
    component: (
      <Suspense fallback={<Loading />}>
        <CourseDetailPage />
      </Suspense>
    ),
    roles: ["Admin", "Süper Admin", "Öğrenci"],
  },
  {
    path: "/ogrencilerim",
    component: (
      <Suspense fallback={<Loading />}>
        <StudentForTeacher />
      </Suspense>
    ),
    roles: ["Öğretmen", "Diyetisyen"],
  },
  {
    path: "/cevrimici/ekle",
    component: (
      <Suspense fallback={<Loading />}>
        <CreateOnlineCoursePage />
      </Suspense>
    ),
    roles: ["Admin", "Süper Admin"],
  },
  {
    path: "/kurs/duzenle/:id",
    component: (
      <Suspense fallback={<Loading />}>
        <CourseUpdatePage />
      </Suspense>
    ),
    roles: ["Admin", "Süper Admin"],
  },
  {
    path: "/sorumlukurslar",
    component: (
      <Suspense fallback={<Loading />}>
        <TeacherCoursePage />
      </Suspense>
    ),
    roles: ["Öğretmen"],
  },
  {
    path: "/kurslarim",
    component: (
      <Suspense fallback={<Loading />}>
        <StudentCourseDashboard />
      </Suspense>
    ),
    roles: ["Öğrenci"],
  },
  {
    path: "/profil",
    component: (
      <Suspense fallback={<Loading />}>
        <ProfilePage />
      </Suspense>
    ),
    roles: ["Öğretmen", "Öğrenci", "Admin", "Süper Admin"],
  },
  {
    path: "/egitmen/sinav",
    component: (
      <Suspense fallback={<Loading />}>
        <TeacherExamPage />
      </Suspense>
    ),
    roles: ["Öğretmen"],
  },
  {
    path: "/egitmen/mesaj",
    component: (
      <Suspense fallback={<Loading />}>
        <TeacherMessagePage />
      </Suspense>
    ),
    roles: ["Öğretmen"],
  },
  {
    path: "/ogrenci/mesaj",
    component: (
      <Suspense fallback={<Loading />}>
        <StudentMessagePage />
      </Suspense>
    ),
    roles: ["Öğrenci"],
  },
  {
    path: "/canliderslerim",
    component: (
      <Suspense fallback={<Loading />}>
        <TeacherOnlineMeetingPage />
      </Suspense>
    ),
    roles: ["Öğretmen", "Öğrenci"],
  },
  {
    path: "/egitmen/canliders",
    component: (
      <Suspense fallback={<Loading />}>
        <TeacherOnlineMeetingPage />
      </Suspense>
    ),
    roles: ["Öğretmen"],
  },
  {
    path: "/egitmen/canliders/odevler/:courseWorkId",
    component: (
      <Suspense fallback={<Loading />}>
        <TeacherOnlineMeetingWorksPage />
      </Suspense>
    ),
    roles: ["Öğretmen"],
  },
  {
    path: "/ogrenci/canliders",
    component: (
      <Suspense fallback={<Loading />}>
        <StudentOnlineMeeting />
      </Suspense>
    ),
    roles: ["Öğrenci"],
  },
  {
    path: "/duyurular",
    component: (
      <Suspense fallback={<Loading />}>
        <AnnouncementPage />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
  {
    path: "/cevrimicidetay",
    component: (
      <Suspense fallback={<Loading />}>
        <CevrimiciDetay />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
  {
    path: "/egitmen/ogrencilerim",
    component: (
      <Suspense fallback={<Loading />}>
        <OgrencilerimPage />
      </Suspense>
    ),
    roles: ["Öğretmen"],
  },
  {
    path: "/istatistik",
    component: (
      <Suspense fallback={<Loading />}>
        <AdminStatisticPage />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
  {
    path: "/sms/ogrenci",
    component: (
      <Suspense fallback={<Loading />}>
        <SmsPage />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
  {
    path: "/devamsizlik",
    component: (
      <Suspense fallback={<Loading />}>
        <OgrenciDevamsızlıkPage />
      </Suspense>
    ),
    roles: ["Öğrenci"],
  },
  {
    path: "/odeme",
    component: (
      <Suspense fallback={<Loading />}>
        <PaymentControl />
      </Suspense>
    ),
    roles: ["Öğrenci"],
  },
  {
    path: "/puantaj",
    component: (
      <Suspense fallback={<Loading />}>
        <Tallys />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
  {
    path: "/devamsizlik-kaldir",
    component: (
      <Suspense fallback={<Loading />}>
        <RemoveAbsences />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
  {
    path: "/odemeler",
    component: (
      <Suspense fallback={<Loading />}>
        <Payments />
      </Suspense>
    ),
    roles: ["Öğrenci"],
  },
  {
    path: "/diyetisyenlik/kayit-ekrani",
    component: (
      <Suspense fallback={<Loading />}>
        <DietitianRegistrationPage />
      </Suspense>
    ),
    roles: ["Süper Admin", "Öğrenci"],
  },
  {
    path: "/diyetisyenlik/kayitli-randevularim",
    component: (
      <Suspense fallback={<Loading />}>
        <DietitianAppointmentPage />
      </Suspense>
    ),
    roles: ["Öğrenci"],
  },
  {
    path: "/sorumlu-diyetisyenliklerim",
    component: (
      <Suspense fallback={<Loading />}>
        <DietitianResponsibleAppointments />
      </Suspense>
    ),
    roles: ["Diyetisyen"],
  },
  {
    path: "/basvurularim",
    component: (
      <Suspense fallback={<Loading />}>
        <MyApplications />
      </Suspense>
    ),
    roles: ["Diyetisyen"],
  },
  {
    path: "/diyetisyen/canliders",
    component: (
      <Suspense fallback={<Loading />}>
        <DietitianOnlineMeetingPage />
      </Suspense>
    ),
    roles: ["Diyetisyen"],
  },
  {
    path: "/diyetisyen-yonetimi",
    component: (
      <Suspense fallback={<Loading />}>
        <DietitianManagementDashboard />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
  {
    path: "/diyetisyenlik/detaylar",
    component: (
      <Suspense fallback={<Loading />}>
        <DieticianDetails />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
  {
    path: "/diyetisyenlik/randevu-detay",
    component: (
      <Suspense fallback={<Loading />}>
        <DieticianEducationDetails />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
  {
    path: "/diyetisyen/ekle",
    component: (
      <Suspense fallback={<Loading />}>
        <AddDietitianPage />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
  {
    path: "/diyetisyen/duzenle/:id",
    component: (
      <Suspense fallback={<Loading />}>
        <EditDietitianPage />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
   {
    path: "/genel-bilgiler",
    component: (
      <Suspense fallback={<Loading />}>
        <GenelBilgiler />
      </Suspense>
    ),
    roles: ["Öğrenci"],
  }
];
